if (!customElements.get('back-in-stock-button')) {
  class BackInStockButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.back-in-stock-button');
      this.buttonText = this.querySelector('.back-in-stock-button span');
      this.spinner = this.querySelector('.loading__spinner');
      this.fallbackButton = this.querySelector('.back-in-stock-fallback');
      this.targetClass = 'frcp-wishlist-wrapper';
      this.iconClass = 'frcp-wishlist-btn';
      this.iconRemoveClass = 'frcp-wishlist-btn--remove';
      this.iconLoadingClass = 'frcp-wishlist-btn--loading';
      this.modalWrapperClass = 'frcp-popup-wrapper';
      this.modalOpenClass = 'frcp-popup-wrapper--open';
      this.modalLoginClass = 'frcp-login';
      this.modalTitleClass = 'frcp-popup__title';
      this.initialText = this.dataset.initialText;
      this.submittedText = this.dataset.submittedText;
      this.loginText = this.dataset.loginText;
      this.isLoading = false;
      this.frcpProcessing = false;
      this.icon = null;
    }

    connectedCallback() {
      this.observeTarget();
      this.setupClickHandler();
      this.observeLoginModal();
      
      const existingWrapper = document.querySelector(`.${this.targetClass}`);
      if (existingWrapper) {
        this.setupIconSync(existingWrapper);
      }
    }

    hasRequiredElements() {
      return this.button && this.spinner && this.buttonText;
    }

    setupClickHandler() {
      if (!this.button) return;

      this.button.addEventListener('click', () => {
        if (!this.icon) return;
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.enableLoading();
        this.icon.click();
      });
    }

    enableLoading() {
      if (!this.hasRequiredElements()) return;

      this.isLoading = true;
      this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.add('loading');
      this.spinner.classList.remove('hidden');
    }

    disableLoading() {
      if (!this.hasRequiredElements()) return;

      this.isLoading = false;
      this.button.removeAttribute('aria-disabled');
      this.button.classList.remove('loading');
      this.spinner.classList.add('hidden');
    }

    setButtonState(isSubmitted) {
      if (!this.button || !this.buttonText) return;
      if (this.isLoading) return;

      this.button.disabled = isSubmitted;
      this.buttonText.textContent = isSubmitted ? this.submittedText : this.initialText;
    }

    observeTarget() {
      const observer = new MutationObserver((mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
              const wrapper = node.classList?.contains(this.targetClass)
                ? node
                : node.querySelector?.(`.${this.targetClass}`);

              if (wrapper) {
                this.setupIconSync(wrapper);
              }
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    observeLoginModal() {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
              if (node.classList?.contains(this.modalWrapperClass)) {
                const loginModal = node.querySelector(`.${this.modalLoginClass}`);
                if (loginModal && node.classList.contains(this.modalOpenClass)) {
                  this.handleLoginModal(node);
                }
              } else if (node.querySelector) {
                const wrapper = node.querySelector(`.${this.modalOpenClass} .${this.modalLoginClass}`);
                if (wrapper) {
                  this.handleLoginModal(wrapper.closest(`.${this.modalWrapperClass}`));
                }
              }
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    handleLoginModal(modal) {
      this.disableLoading();

      if (this.loginText) {
        const title = modal.querySelector(`.${this.modalTitleClass}`);
        if (title) title.innerHTML = this.loginText;
      }
    }

    setupIconSync(wrapper) {
      this.icon = wrapper.querySelector(`.${this.iconClass}`);

      if (!this.icon || !this.button) return;

      this.icon.addEventListener('click', () => {
        if (!this.isLoading) {
          this.enableLoading();
        }
      });

      const updateButtonState = () => {
        const isSubmitted = this.icon.classList.contains(this.iconRemoveClass);
        const isFrcpLoading = this.icon.classList.contains(this.iconLoadingClass);

        if (isFrcpLoading) {
          this.frcpProcessing = true;
          return;
        }

        if (this.frcpProcessing) {
          this.disableLoading();
          this.frcpProcessing = false;
        }

        if (isSubmitted) {
          this.setButtonState(true);
        } else if (!this.isLoading) {
          this.setButtonState(false);
        }
      };

      updateButtonState();

      this.button.style.display = '';
      this.fallbackButton.style.display = 'none';

      const iconObserver = new MutationObserver(updateButtonState);
      iconObserver.observe(this.icon, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  customElements.define('back-in-stock-button', BackInStockButton);
}
